'use strict';

var $ = require('jquery'),
  Backbone = require('backbone'),
  confirmViewTemplate = require('../../tmpl/client/components/confirm-view.hbs'),
  EVENTS = {
    confirmed: 'confirmed',
    cancelled: 'cancelled'
  };

Backbone.$ = $;

var ConfirmView = Backbone.View.extend({

  initialize: function(options) {
    options = options || {};
    this.headerText = options.headerText;
    this.messageText = options.messageText;
    this.confirmText = options.confirmText;
    this.errorText = options.errorText;
  },

  tagName: 'section',
  className: 'ConfirmView',

  events: {
    'submit form': 'onFormSubmit',
    'click [val="confirm"]': 'onFormSubmit',
    'click [val="cancel"]': 'onCancel'
  },

  render: function() {
    this.$el.html(confirmViewTemplate({
      headerText: this.headerText,
      messageText: this.messageText,
      confirmText: this.confirmText,
      errorText: this.errorText
    }));
    this.$errorMessage = this.$('.Modal-errorMessage');
    this.updateUiState();
    return this;
  },

  onFormSubmit: function(e) {
    this.trigger(EVENTS.confirmed);
    e.preventDefault();
  },

  onCancel: function(e) {
    e.preventDefault();
    this.trigger(EVENTS.cancelled);
  },

  resetView: function() {
    this.removeError();
  },

  setError: function(errorText) {
    this.errorText = errorText || this.errorText;
    if (this.errorText) {
      this.$errorMessage.text(errorText).show();
    } else {
      this.$errorMessage.text('').hide();
    }
  },

  removeError: function() {
    this.errorText = '';
    this.setError();
  },

  updateUiState: function() {
    this.setError();
  }

}, {
  EVENTS: EVENTS
});

module.exports = ConfirmView;



// WEBPACK FOOTER //
// ./assets/js/components/ConfirmView.js